import React from "react";
import { ReactComponent as CloseIcon } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as LogoutConfirmIcon } from "../../assets/images/icons/LogoutConfirmIcon.svg";
import { ReactComponent as DiscardIcon } from "../../assets/images/icons/DiscardIcon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/DeleteConfirmIcon.svg";
import { ReactComponent as ConfirmIcon } from "../../assets/images/icons/ConfirmIcon.svg";
import Button from "./DefaultButton";
import { Dialog } from "@mui/material";

const dialogIcon = {
  discard: <DiscardIcon />,
  delete: <DeleteIcon />,
  logout: <LogoutConfirmIcon />,
  primary: <ConfirmIcon />,
};

const borderLine = {
  delete: "border-t-[5px] border-[#F84545]",
  discard: "border-t-[5px] border-[#C8923B]",
  primary: "border-t-[5px] border-[#1D4469]",
};

const ConfirmationDialogMulti = ({
  open,
  onClose,
  title,
  message,
  onConfirm,
  onCancel,
  confirmVariant = "primary",
  cancelVariant = "secondary",
  confirmText,
  cancelText,
  icon,
  iconVariant,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className={` bg-white w-min-[425px] w-max-[425px]  w-[425px]  py-5 px-2 ${borderLine[confirmVariant]} `}>
        {/* <button className="w-full flex justify-end" onClick={onClose}>
          <CloseIcon />
        </button> */}

        <div className="flex items-center gap-5 px-2">
          <span className="w-30">{dialogIcon[iconVariant]}</span>

          <div className="flex flex-col justify-start space-y-1">
            <span className="text-lg font-semibold text-[#666]">{title}</span>
            <p className="text-base font-normal text-[#383838]">{message}</p>
          </div>
        </div>
      </div>
      <div className="h-[1px] w-full bg-[#BECBD3] " />

      <div className="flex justify-end gap-4 items-center px-5 py-3">
        <Button size="medium" onClick={() => (onCancel ? onCancel() : onClose())} variant={cancelVariant}>
          {cancelText ? cancelText : "No"}
        </Button>

        <Button size="medium" onClick={onConfirm} variant={confirmVariant}>
          {confirmText ? confirmText : "Yes"}
        </Button>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialogMulti;
